import React, { Component } from 'react'
import ReactZendesk from 'react-zendesk'

import { ZENDESK_WIDGET_ID } from '../../constants/constants'

export default class Zendesk extends Component {
  render() {
    return <ReactZendesk
      zendeskKey={ZENDESK_WIDGET_ID}
    />
  }
}
